import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
const ADMIN_URL = `${BASE_URL}/admin`;

const authInterceptor = (req) => {
  try {
    const profile = localStorage.getItem("profile");
    if (profile) {
      const accessToken = JSON.parse(profile)?.accessToken;
      if (accessToken) {
        req.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
  } catch (error) {
    // If parsing fails, just continue without auth token (for public access)
    console.warn("Failed to parse profile from localStorage:", error);
  }
  return req;
};

const adminAuthInterceptor = (req) => {
  try {
    const admin = localStorage.getItem("admin");
    if (admin) {
      const accessToken = JSON.parse(admin)?.accessToken;
      if (accessToken) {
        req.headers.Authorization = `Bearer ${accessToken}`;
      }
    }
  } catch (error) {
    // If parsing fails, just continue without auth token
    console.warn("Failed to parse admin from localStorage:", error);
  }
  return req;
};

export const API = axios.create({
  baseURL: BASE_URL,
});

export const ADMIN_API = axios.create({
  baseURL: ADMIN_URL,
});

export const COMMUNITY_API = axios.create({
  baseURL: BASE_URL,
});

API.interceptors.request.use(authInterceptor);
ADMIN_API.interceptors.request.use(adminAuthInterceptor);
COMMUNITY_API.interceptors.request.use((req) => {
  req.headers["Content-Type"] = "application/json";
  return authInterceptor(req);
});

export const handleApiError = async (error) => {
  try {
    const errorMessage =
      error.response?.data?.message || "An unexpected error occurred.";
    const data = null;
    return { error: errorMessage, data };
  } catch (err) {
    throw new Error("An unexpected error occurred.");
  }
};
